import {
  Component,
  input,
  InputSignal
} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-analytics-footer-info',
  imports: [TranslatePipe],
  templateUrl: './analytics-footer-info.component.html',
  styleUrl: './analytics-footer-info.component.scss',
})
export class AnalyticsFooterInfoComponent {

  public readonly iOsMode: InputSignal<boolean> = input<boolean>(false);

}
